// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { DepartmentFragment } from './city-tax-department.fragment.generated';
import { InvoiceBlockRulesFragment } from '../../../../invoice/graphql/fragments/generated/invoice-block-rules.fragment.generated';
export type OwnerCorporateDataFragment = { __typename?: 'OwnerCorporateDataDTO', address: string | null, available: boolean, cashRegisterMode: Types.CashRegisterModeDto | null, city: string | null, cityId: number | null, cityTaxDepartmentId: number | null, cityTaxVatReference: string | null, corpName: string, defaultOwnerCorporateData: boolean, depositDepartmentId: number | null, eInvoicingMode: Types.EInvoicingModeEnumDto | null, eInvoiceManagerAncillaryField1: string | null, eInvoiceManagerAncillaryField2: string | null, eInvoiceManagerHotelCode: string | null, eInvoiceManagerProvider: Types.EInvoiceManagerProviderEnumDto | null, eInvoiceManagerUsername: string | null, eInvoiceTransmitterMail: string | null, eInvoiceTransmitterStateId: number | null, eInvoiceTransmitterTelephone: string | null, eInvoiceTransmitterVATNumber: string | null, eInvoicingAutoCheck: boolean, eInvoiceManagerPasswordSet: boolean, fax: string | null, fiscalAddress: string | null, fiscalCity: string | null, fiscalCityId: number | null, fiscalCode: string | null, fiscalState: string | null, fiscalStateId: number | null, fiscalZip: string | null, iban: string | null, id: number, mail: string | null, mobile: string | null, ownerId: number, place: string | null, reaNumber: string | null, reaOffice: string | null, shareCapital: number | null, site: string | null, stars: number | null, state: string | null, stateId: number | null, telephone: string | null, type: string | null, visualizationOrder: number | null, vatNumber: string | null, zip: string | null, liquidationProcess: Types.LiquidationProcessEnumDto | null, fiscalSystem: Types.FiscalSystemEnumDto | null, defaultVatChargeability: Types.DefaultVatChargeabilityEnumDto | null, cityTaxVatType: Types.CityTaxVatTypeEnumDto | null, cityTaxDepartment: { __typename?: 'DepartmentDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, sellGoods: boolean, vatRateId: number, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null, vatRate: { __typename?: 'VatRateDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, ownerId: number, rate: number, referenceOnZeroVat: string | null, naturaTypeOnZeroVat: Types.NaturaTypeEnumDto | null, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null } } | null, depositDepartment: { __typename?: 'DepartmentDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, sellGoods: boolean, vatRateId: number, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null, vatRate: { __typename?: 'VatRateDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, ownerId: number, rate: number, referenceOnZeroVat: string | null, naturaTypeOnZeroVat: Types.NaturaTypeEnumDto | null, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null } } | null, invoiceBlockRules: { __typename?: 'InvoiceBlockRulesDTO', blockOptional: boolean, blocks: Array<string> } | null };

export const OwnerCorporateDataFragment = gql`
    fragment OwnerCorporateData on OwnerCorporateDataDTO {
  address
  available
  cashRegisterMode
  city
  cityId
  cityTaxDepartment {
    ...Department
  }
  cityTaxDepartmentId
  cityTaxVatReference
  corpName
  defaultOwnerCorporateData
  depositDepartment {
    ...Department
  }
  depositDepartmentId
  eInvoicingMode
  eInvoiceManagerAncillaryField1
  eInvoiceManagerAncillaryField2
  eInvoiceManagerHotelCode
  eInvoiceManagerProvider
  eInvoiceManagerUsername
  eInvoiceTransmitterMail
  eInvoiceTransmitterStateId
  eInvoiceTransmitterTelephone
  eInvoiceTransmitterVATNumber
  eInvoicingAutoCheck
  eInvoiceManagerPasswordSet
  fax
  fiscalAddress
  fiscalCity
  fiscalCityId
  fiscalCode
  fiscalState
  fiscalStateId
  fiscalZip
  iban
  id
  invoiceBlockRules {
    ...InvoiceBlockRules
  }
  mail
  mobile
  ownerId
  place
  reaNumber
  reaOffice
  shareCapital
  site
  stars
  state
  stateId
  telephone
  type
  visualizationOrder
  vatNumber
  zip
  liquidationProcess
  fiscalSystem
  defaultVatChargeability
  cityTaxVatType
}
    ${DepartmentFragment}
${InvoiceBlockRulesFragment}`;
/* eslint-enable */